// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.noticesFilter {
    margin: 0 8px;
}

.noticesMain {
    font-size: 14px;
    line-height: initial;
}

.noticesSub {
    font-size: 10px;
    line-height: initial;
}

.content {
    padding: 0 8px;
}

.noticesText {
    margin-top: 8px;
    white-space: pre-wrap;
    word-break: break-word;
    font-size: 13px;
    color: black;
    line-height: initial;
}
`, "",{"version":3,"sources":["webpack://./src/app/components/common/thirdpartynotices/thirdparty.notices.control.css"],"names":[],"mappings":"AAAA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,qBAAqB;IACrB,sBAAsB;IACtB,eAAe;IACf,YAAY;IACZ,oBAAoB;AACxB","sourcesContent":[".noticesFilter {\n    margin: 0 8px;\n}\n\n.noticesMain {\n    font-size: 14px;\n    line-height: initial;\n}\n\n.noticesSub {\n    font-size: 10px;\n    line-height: initial;\n}\n\n.content {\n    padding: 0 8px;\n}\n\n.noticesText {\n    margin-top: 8px;\n    white-space: pre-wrap;\n    word-break: break-word;\n    font-size: 13px;\n    color: black;\n    line-height: initial;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
